/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 16:13:27
 * @LastEditors: K
 * @LastEditTime: 2022-08-02 16:32:49
 */
import { Button, Col, Row, Space } from 'antd';
import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react'
import { EditableList } from '../../compnents/list/EditableList';
import { NavBar } from '../../compnents/nav/NavBar';
import styles from "./orderRecordPage.module.css";
import { Columns } from "./columns";
import { unwrapResult } from '@reduxjs/toolkit';
import { getOrderList } from '../tenant/tenantSlice';
import { RootDispatch } from '../../app/store';
import { useDispatch } from 'react-redux';

export const OrderRecordPage = () => {

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = location.search.replace('?', '')   //表格数据 ID



  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    tenantId
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })


  const [pageLoading, setPageLoading] = useState(false)

  const getPageList = () => {
    setPageLoading(true)
    dispatch(getOrderList({
      ...params,
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    getPageList()
  }, [params])
  return (
    <>
      <NavBar
        style={{ margin: '10px 20px' }}
        where={['机构管理', '订单记录']}
        backtrace={{
          name: '机构管理',
          path: '/admin/tenant',
        }}
      />

      <div className={styles.wrap}>

        <div className={styles.tableWrap}>
          <EditableList
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            loading={pageLoading}
            className={styles.table}
            columns={Columns(
              (t: any) => {
                console.log(t);
              },
              params.size * (params.current - 1),
            )}
            onChangePage={(current: number, size?: number) => {
              setParams({
                ...params,
                current,
                size
              })
            }

            }
            onRow={(t: any) => ({
              onDoubleClick: () => {
                console.log(t, 'aaaaaaaa');

              },
            })}
          />
        </div>

      </div>
    </>
  );
}

